<auth-progress-steps>
    <!-- Authentication Progress -->
    <div class="progress-container rounded-xl p-6 mb-6">
        <h3 class="progress-title text-lg mb-4 text-center">{locale?.t('authprogress_title')}</h3>
        
        <!-- Progress Steps -->
        <div class="flex justify-between items-center mb-4 relative">
            <!-- Step 1 -->
            <div class="step-item flex flex-col items-center flex-1 relative z-10">
                <div class="step-circle {state.currentStep >= 1 ? (state.currentStep > 1 ? 'step-completed' : 'step-active') : 'step-pending'}">
                    <span if="{state.currentStep > 1}">✓</span>
                    <span if="{state.currentStep <= 1}">1</span>
                </div>
                <span class="step-label mt-2 text-xs text-center">{locale?.t('authprogress_step1')}</span>
            </div>

            <!-- Connector 1-2 -->
            <div class="step-connector {state.currentStep > 1 ? 'step-connector-active' : (state.currentStep === 1 ? 'step-connector-partial' : '')}"></div>

            <!-- Step 2 -->
            <div class="step-item flex flex-col items-center flex-1 relative z-10">
                <div class="step-circle {state.currentStep >= 2 ? (state.currentStep > 2 ? 'step-completed' : 'step-active') : 'step-pending'}">
                    <span if="{state.currentStep > 2}">✓</span>
                    <span if="{state.currentStep <= 2}">2</span>
                </div>
                <span class="step-label mt-2 text-xs text-center">{locale?.t('authprogress_step2')}</span>
            </div>

            <!-- Connector 2-3 -->
            <div class="step-connector {state.currentStep > 2 ? 'step-connector-active' : (state.currentStep === 2 ? 'step-connector-partial' : '')}"></div>

            <!-- Step 3 -->
            <div class="step-item flex flex-col items-center flex-1 relative z-10">
                <div class="step-circle {state.currentStep >= 3 ? (state.currentStep > 3 ? 'step-completed' : 'step-active') : 'step-pending'}">
                    <span if="{state.currentStep > 3}">✓</span>
                    <span if="{state.currentStep <= 3}">3</span>
                </div>
                <span class="step-label mt-2 text-xs text-center">{locale?.t('authprogress_step3')}</span>
            </div>

            <!-- Connector 3-4 -->
            <div class="step-connector {state.currentStep > 3 ? 'step-connector-active' : (state.currentStep === 3 ? 'step-connector-partial' : '')}"></div>

            <!-- Step 4 -->
            <div class="step-item flex flex-col items-center flex-1 relative z-10">
                <div class="step-circle {state.currentStep >= 4 ? 'step-completed' : 'step-pending'}">
                    <span if="{state.currentStep >= 4}">✓</span>
                    <span if="{state.currentStep < 4}">4</span>
                </div>
                <span class="step-label mt-2 text-xs text-center">{locale?.t('authprogress_step4')}</span>
            </div>
        </div>

        <!-- Status Message -->
        <div if="{state.statusMessage}" class="alert {state.statusType === 'error' ? 'alert-error' : state.statusType === 'success' ? 'alert-success' : 'alert-info'} mt-4">
            <i class="bi {state.statusType === 'error' ? 'bi-exclamation-circle' : state.statusType === 'success' ? 'bi-check-circle' : 'bi-info-circle'}"></i>
            <span>{state.statusMessage}</span>
        </div>
    </div>

    <style>
        .progress-container {
            background: #f7fafc;
            border: 1px solid #e2e8f0;
        }

        .progress-title {
            font-weight: 600;
            color: #2d3748;
        }

        .step-item {
            min-width: 60px;
        }

        .step-circle {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 0.95rem;
            transition: all 0.3s ease;
            position: relative;
            z-index: 2;
        }

        .step-pending {
            background-color: #e2e8f0;
            color: #4a5568;
        }

        .step-active {
            background-color: #4299e1;
            color: white;
            animation: pulse 2s infinite;
        }

        .step-completed {
            background-color: #48bb78;
            color: white;
        }

        @keyframes pulse {
            0% {
                box-shadow: 0 0 0 0 rgba(66, 153, 225, 0.7);
            }
            70% {
                box-shadow: 0 0 0 10px rgba(66, 153, 225, 0);
            }
            100% {
                box-shadow: 0 0 0 0 rgba(66, 153, 225, 0);
            }
        }

        .step-label {
            color: #4a5568;
            font-weight: 500;
            line-height: 1.2;
            margin-top: 8px;
            white-space: pre-line;
        }

        .step-item:has(.step-active) .step-label {
            color: #4299e1;
            font-weight: 600;
        }

        .step-item:has(.step-completed) .step-label {
            color: #48bb78;
            font-weight: 600;
        }

        .step-connector {
            position: absolute;
            height: 2px;
            background-color: #e2e8f0;
            top: 20px;
            transition: all 0.3s ease;
            z-index: 1;
        }

        /* Connector positioning */
        .step-connector:nth-of-type(2) {
            left: calc(12.5% + 20px);
            width: calc(25% - 40px);
        }

        .step-connector:nth-of-type(4) {
            left: calc(37.5% + 20px);
            width: calc(25% - 40px);
        }

        .step-connector:nth-of-type(6) {
            left: calc(62.5% + 20px);
            width: calc(25% - 40px);
        }

        /* Active connector with gradient effect */
        .step-connector-active {
            background: linear-gradient(to right, #48bb78 0%, #48bb78 100%);
        }

        /* Partial gradient for currently active step */
        .step-connector-partial {
            background: linear-gradient(to right, #48bb78 50%, #e2e8f0 50%);
        }
    </style>

    <script>
        export default {
            state: {
                currentStep: 1,
                statusMessage: '',
                statusType: 'info'
            },

            onMounted() {
                // Initialize with props if provided
                if (this.props.currentStep) {
                    this.state.currentStep = this.props.currentStep;
                }
                if (this.props.statusMessage) {
                    this.state.statusMessage = this.props.statusMessage;
                }
                if (this.props.statusType) {
                    this.state.statusType = this.props.statusType;
                }
            },

            onUpdated() {
                // Update from props
                if (this.props.currentStep !== undefined && this.props.currentStep !== this.state.currentStep) {
                    this.state.currentStep = this.props.currentStep;
                }
                if (this.props.statusMessage !== undefined && this.props.statusMessage !== this.state.statusMessage) {
                    this.state.statusMessage = this.props.statusMessage;
                }
                if (this.props.statusType !== undefined && this.props.statusType !== this.state.statusType) {
                    this.state.statusType = this.props.statusType;
                }
            }
        }
    </script>
</auth-progress-steps>